import { ReactElement } from 'react';

import { AutoscalerBehaviourField } from 'features/cluster/workload-optimization/_woop-settings/_components/hpa-fields/AutoscalerBehaviourField';

import { BasicBehaviorField } from '../../../../../_woop-settings/_components/hpa-fields/BasicBehaviorField';
import { TriggersField } from '../../../../../_woop-settings/_components/hpa-fields/TriggersField';
import { HpaSettingsForm } from '../../../../../_woop-settings/_components/layout/HpaSettingsForm';
import { hpaSettingsConstants } from '../../../../../_woop-settings/_constants/hpaSettingsConstants';
import { useHpaSelectedSettingName } from '../../../../../_woop-settings/hpaSelectedSettingNameContexts';
import { WorkloadHpaFormSettings } from '../_constants';

import { RffControlsProvider } from '@cast/shared-rff-ui';

export const HpaSettingsContent = () => {
  const { settingName } = useHpaSelectedSettingName<WorkloadHpaFormSettings>();
  const settingContent: Record<WorkloadHpaFormSettings, ReactElement> = {
    basicBehavior: (
      <RffControlsProvider namePrefix="basicBehavior">
        <HpaSettingsForm {...hpaSettingsConstants.basicBehavior}>
          <BasicBehaviorField />
        </HpaSettingsForm>
      </RffControlsProvider>
    ),
    metrics: (
      <RffControlsProvider namePrefix="metrics">
        <HpaSettingsForm {...hpaSettingsConstants.metrics}>
          <TriggersField />
        </HpaSettingsForm>
      </RffControlsProvider>
    ),
    autoscalerBehavior: (
      <RffControlsProvider namePrefix="autoscalerBehavior">
        <HpaSettingsForm {...hpaSettingsConstants.autoscalerBehavior}>
          <AutoscalerBehaviourField />
        </HpaSettingsForm>
      </RffControlsProvider>
    ),
  };

  return (
    <RffControlsProvider namePrefix="hpaSettings">
      {settingContent[settingName]}
    </RffControlsProvider>
  );
};
